"use strict";
'use client';

// TODO: Implement with Base UI Pagination
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = Pagination;
var _classVarianceAuthority = require("class-variance-authority");
var _rcPagination = _interopRequireDefault(require("rc-pagination"));
var _Icon = require("../Icon");
var _Button = require("../Button");
var _helpers = require("../../common/helpers");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
// https://www.sharp.com/doctors/search?specialties_facet=Primary+Care+%3E+Family+medicine,Primary+Care+%3E+Internal+medicine&appointment_options=Accepting+new+patients&v=1

var rootClasses = (0, _classVarianceAuthority.cva)(['flex', 'flex-row', 'gap-5', 'justify-center']);
var buttonProps = {
  as: 'a',
  shape: 'circle',
  width: 'auto',
  size: 'xs',
  color: 'transparent'
};

/**
 * Pagination - [API](https://reimagined-adventure-37999z9.pages.github.io/?path=/docs/navigation-pagination) | [DSM](https://sharphealthcare.notion.site/Pagination-39ba3d32e47148778c0061a7014ab124)
 */
function Pagination(_ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var itemRender = function itemRender(current, type, element) {
    if (type === 'page') {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, _objectSpread(_objectSpread({}, buttonProps), {}, {
        className: "font-medium",
        color: current === props.current ? 'primary' : 'transparent',
        "aria-current": current === props.current ? true : undefined,
        "aria-label": "Page ".concat(current),
        children: current
      }));
    }
    if (type === 'prev') {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, _objectSpread(_objectSpread({}, buttonProps), {}, {
        "aria-label": "Previous Page",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          icon: "chevron-left",
          className: "text-primary"
        })
      }));
    }
    if (type === 'next') {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, _objectSpread(_objectSpread({}, buttonProps), {}, {
        "aria-label": "Next Page",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          icon: "chevron-right",
          className: "text-primary"
        })
      }));
    }
    if (type === 'jump-prev' || type === 'jump-next') {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: "button",
        className: "text-sm font-medium h-full leading-8 cursor-not-allowed select-none",
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        "aria-disabled": true,
        disabled: true,
        children: "..."
      });
    }
    return element;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("nav", {
    role: "navigation",
    "aria-label": "Pagination Navigation",
    className: className,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_rcPagination["default"], _objectSpread({
      className: (0, _helpers.cn)(rootClasses()),
      itemRender: itemRender,
      defaultPageSize: 1,
      locale: {
        // Options
        items_per_page: '/ page',
        jump_to: 'Go to',
        jump_to_confirm: 'confirm',
        page: 'Page',
        // Pagination
        prev_page: 'Previous Page',
        next_page: 'Next Page',
        prev_5: 'Previous 5 Pages',
        next_5: 'Next 5 Pages',
        prev_3: 'Previous 3 Pages',
        next_3: 'Next 3 Pages',
        page_size: 'Page Size'
      }
    }, props))
  });
}